<script setup>
import FormInput from "@/Components/FormInput.vue";

import { inject } from "vue";

defineProps({
    driver_or_codriver: {
        type: String,
        default: "driver",
    },
});

const parentProps = inject("myProps");
</script>

<template>
    <div class="mt-4 w-full sm:w-3/4">
        <div class="mb-8 border-b text-lg">
            <template
                v-if="
                    parentProps.selectedEventClass &&
                    parentProps.selectedEventClass.vehicle_type === 'motorcycle'
                "
            >
                Rider info
            </template>
            <strong v-else>{{ driver_or_codriver === "driver" ? "Driver" : "Co-Driver" }} info</strong>
        </div>
        <div class="mt-4">
            <FormInput
                v-model="parentProps.form[driver_or_codriver].name"
                type="text"
                :error="
                    Object.hasOwn(parentProps.form.errors, `${driver_or_codriver}.name`)
                        ? parentProps.form.errors[`${driver_or_codriver}.name`]
                        : null
                "
                :label="'Name' + (driver_or_codriver === 'driver' ? ' *' : '')"
            ></FormInput>
        </div>
        <div class="mt-4">
            <FormInput
                v-model="parentProps.form[driver_or_codriver].surname"
                type="text"
                :error="
                    Object.hasOwn(parentProps.form.errors, `${driver_or_codriver}.surname`)
                        ? parentProps.form.errors[`${driver_or_codriver}.surname`]
                        : null
                "
                class="mt-1 block w-3/4"
                label="Surname"
            ></FormInput>
        </div>

        <div class="mt-4">
            <FormInput
                v-model="parentProps.form[driver_or_codriver].phone"
                type="text"
                :error="
                    Object.hasOwn(parentProps.form.errors, `${driver_or_codriver}.phone`)
                        ? parentProps.form.errors[`${driver_or_codriver}.phone`]
                        : null
                "
                placeholder="+..."
                :label="'Phone number' + (driver_or_codriver === 'driver' ? ' *' : '')"
            ></FormInput>
        </div>

        <div class="mt-4">
            <FormInput
                v-model="parentProps.form[driver_or_codriver].country"
                type="select"
                :label="'Country' + (driver_or_codriver === 'driver' ? ' *' : '')"
                :error="
                    Object.hasOwn(parentProps.form.errors, `${driver_or_codriver}.country`)
                        ? parentProps.form.errors[`${driver_or_codriver}.country`]
                        : null
                "
                :options="parentProps.countries"
            />
        </div>

        <template v-if="$page.props.event.type === 'full'">
            <div class="mt-4">
                <FormInput
                    v-model="parentProps.form[driver_or_codriver].date_of_birth"
                    :error="
                        Object.hasOwn(parentProps.form.errors, `${driver_or_codriver}.date_of_birth`)
                            ? parentProps.form.errors[`${driver_or_codriver}.date_of_birth`]
                            : null
                    "
                    label="Date of birth"
                    type="date"
                ></FormInput>
            </div>

            <div class="mt-4">
                <FormInput
                    v-model="parentProps.form[driver_or_codriver].city"
                    type="text"
                    :error="
                        Object.hasOwn(parentProps.form.errors, `${driver_or_codriver}.city`)
                            ? parentProps.form.errors[`${driver_or_codriver}.city`]
                            : null
                    "
                    label="City"
                ></FormInput>
            </div>

            <div class="mt-4">
                <FormInput
                    v-model="parentProps.form[driver_or_codriver].emergency_phone"
                    type="text"
                    :error="
                        Object.hasOwn(parentProps.form.errors, `${driver_or_codriver}.emergency_phone`)
                            ? parentProps.form.errors[`${driver_or_codriver}.emergency_phone`]
                            : null
                    "
                    placeholder="+..."
                    label="Emergency family member phone number"
                ></FormInput>
            </div>

            <div class="mt-4">
                <FormInput
                    v-model="parentProps.form[driver_or_codriver].email"
                    type="text"
                    :error="
                        Object.hasOwn(parentProps.form.errors, `${driver_or_codriver}.email`)
                            ? parentProps.form.errors[`${driver_or_codriver}.email`]
                            : null
                    "
                    label="Email"
                ></FormInput>
            </div>

            <div class="mt-4">
                <FormInput
                    v-model="parentProps.form[driver_or_codriver].driver_licence"
                    type="text"
                    :error="
                        Object.hasOwn(parentProps.form.errors, `${driver_or_codriver}.driver_licence`)
                            ? parentProps.form.errors[`${driver_or_codriver}.driver_licence`]
                            : null
                    "
                    label="Drivers licence number"
                ></FormInput>
            </div>

            <div class="mt-4">
                <FormInput
                    v-model="parentProps.form[driver_or_codriver].asn_licence"
                    type="text"
                    :error="
                        Object.hasOwn(parentProps.form.errors, `${driver_or_codriver}.asn_licence`)
                            ? parentProps.form.errors[`${driver_or_codriver}.asn_licence`]
                            : null
                    "
                    label="Competitor licence number and issuing ASN"
                    tooltip="ASN = Autorité Sportive Nationale"
                ></FormInput>
            </div>

            <div class="mt-4">
                <FormInput
                    v-model="parentProps.form[driver_or_codriver].insurance"
                    type="text"
                    :error="
                        Object.hasOwn(parentProps.form.errors, `${driver_or_codriver}.insurance`)
                            ? parentProps.form.errors[`${driver_or_codriver}.insurance`]
                            : null
                    "
                    label="Competitor insurance policy company and number"
                ></FormInput>
            </div>
        </template>
    </div>
</template>
